<template>
  <div class="auth-page">
    <div class="auth-form">
      <a href="/" class="auth-page__a-logo">
        <img
          class="auth-page__logo"
          src="@/assets/media/logo.png"
          srcset="@/assets/media/logo@2x.png 2x"
        />
      </a>

      <div v-if="error" class="auth__error">{{ error }}</div>

      <div class="auth-form__header">
        <i class="material-icons">vpn_key</i>
        <span>Recover password</span>
      </div>

      <template v-if="!mailSent">
        <template v-if="!busy">
          <div class="field-wrapper">
            <i class="material-icons material-icon-input--16"> alternate_email </i>
            <input
              ref="email"
              v-model="email"
              v-focus
              type="email"
              placeholder="email"
              name="email"
              :disabled="busy"
              v-bind:class="{ 'input--not-valid': !emailValid }"
              @keydown.13="sendRecoveryLink"
            />
          </div>

          <button v-if="!busy" type="button" :disabled="!emailValid" @click="sendRecoveryLink()">
            Send recovery link
          </button>

          <p class="message">
            Back to
            <router-link :to="{ name: 'login' }">Log In</router-link>
            or
            <router-link :to="{ name: 'signup' }">Create an account</router-link>
          </p>
        </template>
        <template v-else>
          <img src="@/assets/img/spinner.gif" style="width: 16px; padding: 48px 0" />
          <div>Sending recovery link to {{ email }}</div>
        </template>
      </template>

      <template v-else>
        <div style="margin-top: 32px">
          Recovery link sent to {{ email }}, <b>check your mailbox.</b><br /><br />
          <a href="/auth/login/">Log in</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import AuthAPI from 'api/auth';
  import PageTitle from '@/mixins/page-title';
  import { validateEmail } from '@/utils/validators';

  const ErrorEmailNotValid = 'Email is not valid';
  const ErrorGeneral = 'An error occurred, try again';

  export default {
    name: 'RecoverPasswordPage',
    mixins: [PageTitle],
    data() {
      return {
        pageTitle: 'HPLC Cloud: Password recovery',

        validate: false,
        email: '',

        busy: false,
        mailSent: false,
        error: null,
      };
    },
    computed: {
      emailValid() {
        if (this.validate) {
          return validateEmail(this.email);
        }
        return true;
      },
    },
    mounted() {
      this.$refs.email.focus();
    },
    methods: {
      sendRecoveryLink() {
        if (!validateEmail(this.email)) {
          this.validate = true;
          this.error = ErrorEmailNotValid;
          return;
        }

        this.error = null;
        this.busy = true;

        const onSuccess = () => {
          this.mailSent = true;
          this.busy = false;
        };

        const onError = (e) => {
          if (e.detail) {
            this.error = e.detail;
          } else {
            this.error = ErrorGeneral;
          }
          this.busy = false;
        };

        AuthAPI.sendPasswordRecoveryLetter(this.email, onSuccess, onError);
      },

      goToIndex() {
        window.location.href = '/';
      },
    },
  };
</script>
